import { render } from "./AddDriverPage.vue?vue&type=template&id=5d8a81d3&scoped=true"
import script from "./AddDriverPage.vue?vue&type=script&lang=js"
export * from "./AddDriverPage.vue?vue&type=script&lang=js"

import "./AddDriverPage.vue?vue&type=style&index=0&id=5d8a81d3&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8a81d3"]])

export default __exports__